import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'video',
  name: '视频',
  icon: '视',
  group: '基础组件',
  description: '播放视频并展示封面和基础控制',
  defaultProps: {
    videoUrl: '',
    posterUrl: '',
    autoplay: false,
    controls: true,
    loop: false
  }
}
